import styled from "styled-components"
import { Background } from "./Input.styles"

export { Wrapper } from "./Input.styles"

export const ToggleContainer = styled(Background)<{ noBorder?: boolean }>`
  display: flex;
  align-items: center;
  min-height: auto;
  padding-top: ${({ theme }) => theme.spacing.less};
  padding-bottom: ${({ theme }) => theme.spacing.less};
  ${(props) => props.noBorder && "border-left-width: 0;"};
`

export const ToggleLabelContainer = styled.div`
  flex: 1 1 auto;
`

export const ToggleContent = styled.span`
  position: relative;
`

export const ToggleInput = styled.input`
  height: 0;
  width: 0;
  visibility: hidden;
  position: absolute;

  &:checked + label {
    background: ${({ theme }) => theme.color.tint.default};
  }

  &:checked + label:after {
    left: calc(100% - 2px);
    transform: translateX(-100%);
  }
`

export const ToggleLabel = styled.label`
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  text-indent: -9999px;
  width: 51px;
  height: 31px;
  background: ${({ theme }) => theme.color.bg.light02};
  display: block;
  border-radius: 21px;
  position: relative;
  transition: background 250ms ease-in-out;
  cursor: pointer;

  &:after {
    content: "";
    position: absolute;
    top: 2px;
    left: 2px;
    width: 27px;
    height: 27px;
    background: ${({ theme }) => theme.color.bg.light01};
    border-radius: 27px;
    transition: 250ms ease-in-out;
    box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.15), 0px 3px 1px rgba(0, 0, 0, 0.06);
  }

  &:active:after {
    // stretching effect - we don't want it at the moment
    // width: 34px;
  }
`
